import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'ALQTeacher',
    label: 'ALQTeacher',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
